import { render } from "./ContactUsConfirmationPage.vue?vue&type=template&id=6daf9d24&scoped=true"
import script from "./ContactUsConfirmationPage.vue?vue&type=script&lang=js"
export * from "./ContactUsConfirmationPage.vue?vue&type=script&lang=js"

import "./ContactUsConfirmationPage.vue?vue&type=style&index=0&id=6daf9d24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6daf9d24"]])

export default __exports__